import React, { useEffect, useState } from "react";
import { api, CATEGORIES } from "../lib/api";
import ProductCard from "./ProductCard";

export default function ProductGrid({ defaultCategory = null, title = "Catálogo", subtitle, onCustomize, hideFilters = false }) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [active, setActive] = useState(defaultCategory);

  useEffect(() => {
    setLoading(true);
    const params = active ? { category: active } : {};
    api.get("/products", { params })
      .then((r) => setProducts(r.data))
      .catch(() => setProducts([]))
      .finally(() => setLoading(false));
  }, [active]);

  return (
    <section id="catalogo" className="py-16 md:py-24 bg-white" data-testid="product-grid">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-10">
          <div>
            <div className="text-xs uppercase tracking-[0.25em] font-bold text-[#0EA5E9]">Catálogo</div>
            <h2 className="font-heading font-black text-4xl md:text-5xl tracking-tight text-black mt-2">{title}</h2>
            {subtitle && <p className="text-slate-600 mt-2 max-w-xl">{subtitle}</p>}
          </div>
          {!hideFilters && (
            <div className="flex flex-wrap gap-2" data-testid="category-filters">
              <FilterButton active={active === null} onClick={() => setActive(null)} label="Todos" />
              {CATEGORIES.map((c) => (
                <FilterButton
                  key={c.key}
                  active={active === c.key}
                  onClick={() => setActive(c.key)}
                  label={c.label}
                  testId={`filter-${c.key}`}
                />
              ))}
            </div>
          )}
        </div>
        {loading ? (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {Array.from({ length: 8 }).map((_, i) => (
              <div key={i} className="aspect-square rounded-2xl bg-slate-100 animate-pulse" />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
            {products.map((p) => (
              <ProductCard key={p.id} product={p} onCustomize={onCustomize} />
            ))}
          </div>
        )}
        {!loading && products.length === 0 && (
          <div className="text-center py-16 text-slate-500">No hay productos en esta categoría aún.</div>
        )}
      </div>
    </section>
  );
}

const FilterButton = ({ active, onClick, label, testId }) => (
  <button
    onClick={onClick}
    data-testid={testId}
    className={`px-4 py-2 rounded-full text-sm font-bold transition ${
      active ? "bg-black text-white" : "bg-slate-100 hover:bg-slate-200 text-slate-700"
    }`}
  >
    {label}
  </button>
);
